import {GenericContact} from '../api/contacts/generic-contact';

export class ContactsDisplayDialogData {
  contacts: GenericContact[];
}
